/**
 * Ordering options for `GET /api/projects`, in the backend's `field,DIRECTION` form.
 *
 * The fields must stay within `EvaluationProjectSearchService.SORTABLE_FIELDS`; anything else is
 * silently ignored by the backend and falls back to newest-first.
 *
 * Note what LAST_CHANGED actually means: it sorts by the project's optimistic-lock column, so it
 * only moves when the project row itself is written — a rename or a settings edit. Adding samples,
 * inviting participants or toggling draft mode do not bump it.
 */
export const ProjectSort = {
  NEWEST: 'createdAt,DESC',
  LAST_CHANGED: 'version,DESC',
  NAME: 'name,ASC'
} as const

export type ProjectSortValue = (typeof ProjectSort)[keyof typeof ProjectSort]

export const projectSortOptions: { value: ProjectSortValue; label: string }[] = [
  { value: ProjectSort.NEWEST, label: 'Newest first' },
  { value: ProjectSort.LAST_CHANGED, label: 'Last changed' },
  { value: ProjectSort.NAME, label: 'Name (A–Z)' }
]
